module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_0.2e6aab09.png";